<div class="row Foot">
     <div class="col-12 p-0 TitleSec">
          <div>
               <h3> Contáctanos </h3>
          </div>
     </div>
     <div class="col-md-4 col-sm-12 mb-3">
          <img class="logosize" src="./Public/Img/LogoFoot.png" alt="Clave" loading="lazy" decoding="async">
     </div>
     <div class="col-md-4 col-sm-12 mb-3">
          Juan de Tolosa 1106, Centro, 98000,  Zacatecas, México <br>
          Teléfono: (492) 922.9639
     </div>
     <div class="col-md-4 col-sm-12 mb-3">
          WhatsApp: (492) 493.4968 <br>
          Correo: ventas&#64;clavemusica.com.mx
          <div class="follow">
               <span class="follow-pill">Siguenos en:</span>
               <a href="https://www.instagram.com/claveinstrumentosmusica" target="_blank"
                    rel="noopener noreferrer" aria-label="Instagram de Clave Winds">
                    <i class='bx bxl-instagram-alt bx-sm'></i>
               </a>
               <a href="https://www.facebook.com/239591079577745" target="_blank"
                    rel="noopener noreferrer" aria-label="Facebook de Clave Winds">
                    <i class='bx bxl-facebook-circle bx-sm'></i>
               </a>
               <a href="https://www.tiktok.com/@clavetreto" target="_blank"
                    rel="noopener noreferrer" aria-label="TikTok de Clave Winds">
                    <i class='bx bxl-tiktok bx-sm'></i>
               </a>
          </div>
     </div>
</div>
<div class="col-12 backToTop">
     <span>© Clavewinds.shop 2025</span>
     <app-scroll-to-top></app-scroll-to-top>
</div>
